import { type Loggable, type SearchDomainContext } from '~/apps/product-plus/search-domain/types';
import { type BettingInsightsElasticSearchContext } from '~/apps/product-plus/search-domain/types/contracts';

export function createElasticSearchContext(context: SearchDomainContext): BettingInsightsElasticSearchContext {
  return {
    isWalled: context.isWalled ?? false,
    repubConfig: context.repubConfig,
    repubCountry: context.repubCountry,
    userPreference: context.userPreference,
  };
}

export function createResponseFactoryContext(context: SearchDomainContext): Loggable {
  return { logger: (context.logger ?? console) as Loggable['logger'] };
}
